import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { EVENTS } from 'shared/constants/gtmEvents';
import { setDataLayer } from 'shared/actions/globals';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withLeasingParams } from 'shared/hocs/withLeasingParams';
// import withHapai from 'shared/hocs/withHapai';

import ToolTipWrapper from 'shared/components/ToolTipWrapper/ToolTipWrapper';
import LeasingWithCalculatorBanner from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorBanner';
import ModalWrapper from 'shared/components/ModalWrapper/ModalWrapper';

// import { toggleHalfScreen } from 'shared/helpers/adsAndMetrics';

// import { getSymbolTitleBySlug } from 'shared/helpers/transportInfo';

// import { isHapaiLeasing } from 'shared/helpers/leasing/utils';
// import { getMonthlyPrice } from 'shared/helpers/leasing/utils';
import CommonLeasingButton from '../CommonLeasingButton/CommonLeasingButton';

// eslint-disable-next-line css-modules/no-unused-class
import s from './LeasingWithCalculatorButton.css';

// const isMobile = __APP__ === 'mobile';
class LeasingWithCalculatorButton extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    // currencySlug: PropTypes.string,
    toggleLeasingModal: PropTypes.func,
    showDialog: PropTypes.bool,
    useToolTip: PropTypes.bool,
    eventPostfix: PropTypes.string,
    children: PropTypes.node,
    //
    setDataLayer: PropTypes.func.isRequired,
    leasingParams: PropTypes.shape(),
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    useToolTip: false,
    toggleLeasingModal: () => {},
    showDialog: false,
    leasingParams: null,
    // currencySlug: 'uah',
    eventPostfix: '',
    children: null,
  };

  state = {
    showDialog: false,
  };

  getTitle = () => {
    const { intl, leasingParams } = this.props;
    let price = 0;
    // if (leasingParams && leasingParams.extendedParams && leasingParams.extendedParams.hapai) {
    //   price = leasingParams.extendedParams.hapai.monthlyPaymentUAHFormatted;
    // } else
    if (leasingParams && leasingParams.extendedParams) {
      price = leasingParams.extendedParams.monthlyPaymentUAHFormatted;
    }

    const symbol = 'грн'; // getSymbolTitleBySlug(currencySlug);
    const moth = intl.formatMessage({ id: 'мес' });
    return `${price} ${symbol}/${moth}`;
  };

  toggleLeasingModal = event => {
    if (event) event.stopPropagation();
    const show = this.props.useToolTip ? this.props.showDialog : this.state.showDialog;
    const showDialog = !show;

    if (!this.props.useToolTip) this.setState({ showDialog });

    if (showDialog) {
      this.pushEvent('monthly-calculation-show-form-click');
    }

    this.props.toggleLeasingModal();
    // if (isMobile) toggleHalfScreen(!showDialog);
  };

  pushEvent = eventName => {
    const { eventPostfix } = this.props;
    // const { eventPostfix, leasingParams } = this.props;
    const partnert = ''; // isHapaiLeasing(leasingParams) ? 'hapai-' : '';
    const event = `${partnert}${eventName}${eventPostfix ? `-${eventPostfix}` : ''}`;
    if (EVENTS.leasing[event]) this.props.setDataLayer(EVENTS.leasing[event]);
    else console.error(`Event: ${event} not found.`);
  };

  render() {
    const { advert, leasingParams, useToolTip, children } = this.props;
    const ComponentWrapper = useToolTip ? ToolTipWrapper : ModalWrapper;
    const show = useToolTip ? this.props.showDialog : this.state.showDialog;
    return (
      <React.Fragment>
        <CommonLeasingButton
          title={this.getTitle()}
          onClick={this.toggleLeasingModal}
          className="leasing-with-calculator"
        >
          {children}
        </CommonLeasingButton>
        <ComponentWrapper toggleModal={this.toggleLeasingModal} show={show}>
          <LeasingWithCalculatorBanner
            eventPostfix={this.props.eventPostfix}
            advertInfo={advert}
            modalMode
            onSubmited={this.toggleLeasingModal}
            leasingParams={leasingParams}
          />
        </ComponentWrapper>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setDataLayer: bindActionCreators(setDataLayer, dispatch),
});

export default withStyles(s)(
  connect(
    null,
    mapDispatchToProps,
  )(withLeasingParams(injectIntl(LeasingWithCalculatorButton))),
);



// WEBPACK FOOTER //
// ./src/shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton.js